import { GetLayout } from "types/page";

export function nestedLayout(wrapperLayout: GetLayout, innerLayout: GetLayout): GetLayout {
  return (page) => wrapperLayout(innerLayout(page))
}